import React from 'react';

interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'email' | 'tel' | 'password';
  error?: boolean;
  disabled?: boolean;
  className?: string;
}

export function TextInput({
  value,
  onChange,
  placeholder = '',
  type = 'text',
  error = false,
  disabled = false,
  className = '',
}: TextInputProps) {
  const baseClasses =
    'w-full px-3 py-2.5 rounded-lg bg-white border text-[#1D314D] placeholder:text-slate-400 focus:ring-2 focus:ring-[#CEAB65]/50 focus:border-[#CEAB65] transition duration-150';
  const errorClasses = error ? 'border-red-500' : 'border-slate-300';
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed bg-slate-50' : '';

  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      className={`${baseClasses} ${errorClasses} ${disabledClasses} ${className}`}
    />
  );
}
